function initializeModalForArticlePictures() {
  const modal = document.getElementById("picModal");
  const closeBtn = document.getElementById("picModalCloseBtn");
  const openTriggers = document.querySelectorAll(".picModalTrigger");
  const html = document.querySelector("html");

  if (!modal || !closeBtn || !html || openTriggers.length === 0) return;

  const closeModal = () => {
    modal.style.display = "none";
    html.style.overflowY = "auto";
    // 背景クリックで閉じるイベントリスナーを削除
    modal.removeEventListener("click", bgClickClose);
  };

  const bgClickClose = (e) => {
    if (e.target === modal) {
      closeModal();
    }
  };

  const openModal = () => {
    modal.style.display = "block";
    html.style.overflowY = "hidden";
    // モーダルを開くときにだけイベントリスナーを追加
    modal.addEventListener("click", bgClickClose);
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener("click", openModal);
  });

  closeBtn.addEventListener("click", closeModal);
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeModalForArticlePictures;